import { render } from "./RewardStatement.vue?vue&type=template&id=3e15b2bc&scoped=true"
import script from "./RewardStatement.vue?vue&type=script&lang=js"
export * from "./RewardStatement.vue?vue&type=script&lang=js"

import "./RewardStatement.vue?vue&type=style&index=0&id=3e15b2bc&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e15b2bc"]])

export default __exports__